module.exports = __webpack_public_path__ + "static/media/Redux.85772647.svg";